import React from 'react'
import styled from 'styled-components'
import HelpIcon from '../../HelpIcon'
import StartingAge from './StartingAge'
import EndingAge from './EndingAge'

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  flex-wrap: wrap;
`

const Label = styled.div`
  display: flex;
`

const SelectsContainer = styled.div`
  display: flex;
`

export default (props) => (
  <Container>
    <Label>
      Years <HelpIcon label='Years' description="The child's age (in years) that you estimate to start and stop paying for each expense on a monthly basis." />
    </Label>
    <SelectsContainer>
      <StartingAge noPaddingLeft label='from' {...props} />
      <EndingAge label='to' {...props} />
    </SelectsContainer>
  </Container>
)
